// src/app/layout/SidebarLayout.jsx

import React from "react";

/**
 * SidebarLayout is a wrapper component for rendering sidebar content with consistent layout and styling.
 *
 * Features:
 * - Dark-themed sidebar background and white text
 * - Vertical flex layout with spacing between children
 * - Responsive width (full width on mobile, fixed 64 width units on desktop)
 * - Optional sticky behavior to keep the sidebar pinned on scroll
 *
 * Props:
 * @param {object} props
 * @param {React.ReactNode} props.children - The sidebar content to render inside the layout
 * @param {string} [props.className] - Optional additional Tailwind CSS classes to apply
 * @param {boolean} [props.sticky=true] - Whether to make the sidebar sticky to the top of the page
 *
 * @returns {JSX.Element} A styled <aside> element wrapping sidebar content
 */
function SidebarLayout({ children, className = "", sticky = true }) {
  return (
    <aside
      className={`bg-gray-900 text-white flex flex-col gap-4
      ${sticky ? "sticky top-0 min-h-full" : "min-h-screen"}
      w-full xl:w-64 ${className}`}
    >
      {children}
    </aside>
  );
}

export default SidebarLayout;
